/** Returns the nearest ancestor with a measurable layout box (skips `display: contents`). */
export function getLayoutParent(el: HTMLElement): HTMLElement | null {
	let parent = el.parentElement;

	while (parent && getComputedStyle(parent).display === 'contents') {
		parent = parent.parentElement;
	}

	return parent;
}
